import axios from "axios";
import { API_BASE_URL } from "../config/Base_Url_Config";

// <------------ user profile api --------->
export const user_Profile = async (header) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/web-user-profile`, {
            headers: header
        });

        return response;
    } catch (error) {
        return error;
    }
}

// <------------ user profile api --------->
export const user_profile_update = async (header, data) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/web-user-profile-update`, data, {
            headers: header
        });

        return response;
    } catch (error) {
        return error;
    }
}

// <------------ User Google Login API --------->
export const user_google_login = async (token) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/user/google-login`,
            { access_token: token },
            { headers: { 'Content-Type': 'application/json' } }
        );
        return response.data; // Return only the data part
    } catch (error) {
        console.error("Google Login Error:", error.response?.data || error.message);
        return { success: false, error: error.response?.data || error.message };
    }
};

// <------------ User Login API --------->
export const user_login = async (formData) => {
    try {
        const response = await axios.post(
            `${API_BASE_URL}/web-user-login`,
            formData,
            { headers: { "Content-Type": "multipart/form-data" } }
        );
        return response.data; // Return only the response data
    } catch (error) {
        console.error("Login Error:", error.response?.data || error.message);
        return { success: false, error: error.response?.data?.message || error.message };
    }
};

// <------------ user profile api --------->
export const user_forgot_password = async (data) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/forgot-password`, data);
        return response;
    } catch (error) {
        return error;
    }
}